// Format numbers to local country standards
export default function(number) {
    return number / 100
  }
  